export class AllocationSummary {
  totalChaseCount: number;
  remainingChaseCount: number;
  completedChaseCount: number;

  constructor(options: Partial<AllocationSummary> = {}) {
    this.totalChaseCount = options.totalChaseCount ?? 0;
    this.remainingChaseCount = options.remainingChaseCount ?? 0;
    this.completedChaseCount = options.completedChaseCount ?? 0;
  }
}
